import "./style.css";

import FormHeadingContract from "../../authentication/login/formHeadingContract";
import { MainDetails } from "../contractDetails/mainDetails";
import { PaymentDetails } from "../contractDetails/paymentDetails";
import { IContractProps } from "../models";
// styles
import styles from "./styles.module.scss";

export const ContractDetails = ({
  contract,
  unAuthenticated = false,
}: IContractProps) => {
  return (
    <>
      <span className="heading-mobile">
        <FormHeadingContract smallScreen={true} />
      </span>
      <div className={styles.contract_container}>
        <MainDetails unAuthenticated={unAuthenticated} contract={contract} />
        <PaymentDetails backgroundColor={"#ffffff"} contract={contract} />
      </div>
    </>
  );
};
